import { Component, DestroyRef, ElementRef, HostListener, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { disconnect, switchChain, watchConnections } from '@wagmi/core';
import { ToastrService } from 'ngx-toastr';
import { Subject, debounceTime, firstValueFrom, takeUntil } from 'rxjs';
import { IdleService } from 'src/app/core/services/idle.service';
import { AccountService } from 'src/app/services/account.service';
import { CommonContractService } from 'src/app/services/common-contract.service';
import { LoginService } from 'src/app/services/login.service';
import { NftManagementService } from 'src/app/services/nft-management.service';
import { SearchService } from 'src/app/services/search.service';
import { DEFAULT_CUSTODY_MODE_IS_REGULATED, StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import Web3 from 'web3';
import { AccountState, IApiResponse, walletAccount } from '../../interface/interface';
import { AppkitService, WalletState } from 'src/app/core/services/appkit.service';
import { getAddress } from 'viem';

@Component({
    selector: 'app-header-new',
    templateUrl: './header-new.component.html',
    styleUrls: ['./header-new.component.scss'],
    standalone: false
})
export class HeaderNewComponent implements OnInit, OnDestroy {
    showMenu: any;
    showSearch: boolean = false;
    @ViewChild('navbarCollapse') navbarCollapse!: ElementRef;
    regulated: any;
    public web3WalletConnect: any;
    public web3: any;
    public account: AccountState;
    public connector: any;
    public chainId: any;
    public provider: any;
    public ethereum: any;
    public authSubscribe: any;
    @Input('collapseStyle') collapseStyle;
    public alertSuccess: boolean;
    public checkNetworkInterval: NodeJS.Timeout;
    private custodyModeTimeout: any;
    private logoutTimeout: any;
    public allowNetwork: boolean;
    public isRegulated: boolean = false;
    private hasExplicitCustodySelection: boolean = false;
    public currentRoute: string = '';
    public web3Modal: any;
    defaultNetwork = environment.SUPPORTED_CHAINS;
    @ViewChild('switchNetworkModal') switchNetworkModal: { show: () => void; hide: () => void; };
    @ViewChild('quickSearchBox') quickSearchBox: ElementRef
    walletProvider: string = '';
    searchDropdown: boolean = false;
    searchLoader: boolean = false;
    searchData = {};
    searchKey: string = '';
    searchControl = new FormControl();
    private unsubscribeSearch$ = new Subject<void>();
    limit = 10;
    searchParams = {
        logPage: 1,
        collectionPage: 1,
        nftPage: 1,
        userPage: 1,
        holdingPage: 1
    };
    // Track loading state for each section
    loadingStates = {
        log: false,
        collection: false,
        nft: false,
        user: false,
        holding: false
    };
    //the visibility state of the "See More" button for various entities.
    canShowSeeMore: ICanShowSeeMore = {
        log: true,
        collection: true,
        nft: true,
        user: true,
        holding: true
    }

    private wagmiLoaded: boolean = false;

    /**
     * Wallet address whose whitelist check / sign-in is currently running.
     * wagmi emits "connected" more than once for a single connection
     * (reconnecting -> connected, chain switch, account list refresh); without
     * this guard each emission started its own challenge and the wallet showed
     * two signature requests at once.
     */
    private whitelistCheckInFlightFor: string | null = null;

    /**
     * Constructors
     */
    constructor(
        private accountService: AccountService,
        private storageService: StorageService,
        private router: Router,
        private toastr: ToastrService,
        private ngzone: NgZone,
        private nftManagementService: NftManagementService,
        private commonservices: CommonContractService,
        private loginService: LoginService,
        private _eref: ElementRef,
        private searchService: SearchService,
        private idleService: IdleService,
        private appkitService: AppkitService,
        private destroyRef: DestroyRef
    ) { }

    /**
      * Initial Loader
      */
    public async ngOnInit() {
        
        this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.currentRoute = this.router.url;
        })

        this.syncCustodyFromStorage();
        //this.web3 = new Web3(window['ethereum'] as any);
        // this.ethereum = window['ethereum'] as any;
        // this.accountService.authValidationsObserve.subscribe((response) => {
        //     console.log('authValidationsObserve', response);
        //     if (response) {
        //         this.logout();
        //     }
        // })
        // this.accountService.walletObserve.subscribe((response) => {
        //     console.log('walletObserve', response);
        //     if (response.status) {
        //         this.connectWalletButton();
        //         const data = {
        //             status: false,
        //         };
        //         this.accountService.openWallet(data);
        //     }
        // });

        this.appkitService.walletState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((state: WalletState) => {

            /**
             * --------------------------------------------
             * Prevent redirect during page reload:
             * --------------------------------------------
             * When the page reloads, Wagmi takes a few seconds
             * to restore the wallet connection. During this time,
             * `state.connected` and `state.walletAddress` will be
             * undefined.
             *
             * To avoid redirecting the user to the login page
             * before Wagmi finishes reconnecting, we skip the
             * redirect until we receive the first valid state.
             */
            if (!this.wagmiLoaded && !state.walletAddress) {
               
                return;
            }

            /**
             * Mark Wagmi as initialized.
             * After this point, we can safely allow redirects.
             */
            this.wagmiLoaded = true;

            /**
             * --------------------------------------------
             * Wallet Connected
             * --------------------------------------------
             * If the user's wallet is connected and we have a
             * valid address, store the connection details and
             * proceed with whitelist validation.
             */
            if (state.connected && state.walletAddress) {
                this.account = {
                account: getAddress(state.walletAddress),
                chainId: Number(state.chainId || environment.SUPPORTED_CHAINS[0]),
                isConnected: state.connected
                };
                this.storageService.setItem('wagmi_new_store', JSON.stringify(this.account));
                this.checkWhitelist();
                return;
            }

            /**
             * --------------------------------------------
             * Wallet NOT Connected
             * --------------------------------------------
             * If the wallet is not connected after Wagmi is fully
             * initialized, clear the stored connection and redirect
             * the user to the login page.
             */
            this.account = {
                account: '',
                chainId: 0,
                isConnected: false
            };
            this.storageService.clearItem();
            this.syncCustodyFromStorage();
            this.idleService.stop();
            this.accountService.accountChange(false);

            // Redirect only after Wagmi has fully loaded
            if (this.wagmiLoaded && this.router.url !== "/") {
                this.ngzone.run(() => this.router.navigate(['/']));
            }
        });

          

        /** common header hide on wallet connect */
        // this.commonservices.sethederhide(true)
        // this.getWalletAddress();

        this.searchControl.valueChanges
            .pipe(
                debounceTime(2000),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(value => {
                this.searchData = {};
                this.resetSearchParams();
                this.quickSearchProcess(value);
            });
        // await this.watchAccountConnections();
    }

    /**
     * Gets wallet address
     */
    // public async getWalletAddress() {

    //     this.account = this.storageService.getItem('wagmi_new_store') === null ?
    //         { address: '', network: '', chainId: '', provider: '' } :
    //         JSON.parse(this.storageService.getItem('wagmi_new_store') as any);
    //     console.log(JSON.parse(this.storageService.getItem('wagmi_new_store') as any), "this.storageService.getItem('wagmi_new_store')")
    //     console.log(this.account, " this.account")
    //     this.walletProvider = JSON.parse(this.storageService.getItem('wagmi.connectedRdns') || 'null');
    //     if (this.account?.state && this.account?.state?.data?.account) {
    //         this.checkWhitelist();
    //     }
    // }
    public async wagmiConfig() {

        // NOTE: The following code is commented out because the AppkitService already initializes the Wagmi configuration. once is working fine will remove this later.

        // wallet connect initialization
        // const chains = [polygon, polygonAmoy]
        // const projectId = environment.WALLET_CONNECT_PROJECT_ID;
        // const suppoertedChain = environment.SUPPORTED_CHAINS[0] == '137' ? polygon : polygonAmoy

        // const metadata = {
        //     name: 'Real World',
        //     description: 'Real World - Market',
        //     url: environment.WEB_SITE_URL,
        //     icons: ['https://avatars.githubusercontent.com/u/37784886']
        // }
        // const wagmiAdapter: any = new WagmiAdapter({ projectId: projectId, networks: [suppoertedChain] })
        // await createAppKit({
        //     adapters: [wagmiAdapter],
        //     networks: [suppoertedChain],
        //     metadata: metadata,
        //     projectId: environment.WALLET_CONNECT_PROJECT_ID,
        //     features: {
        //         socials: false,
        //         email: false
        //     },
        //     themeVariables: {
        //         "--w3m-color-mix": "#063f2dff",
        //         "--w3m-color-mix-strength": 40,
        //         "--w3m-accent": "#06402dff",
        //     }
        // })

        // // Watch for account changes
        // watchAccount(wagmiAdapter.wagmiConfig, {
        //     onChange: (account: any) => {
        //         if (account.isConnected) {
        //             const connectedChainId = account.chainId.toString()
        //             if (environment.SUPPORTED_CHAINS.includes(connectedChainId)) {
        //                 this.switchNetworkModal?.hide();
        //                 this.commonservices?.closeAllModals(false);
        //                 const new_wagmi_store =
        //                 {
        //                     state: {
        //                         data: {
        //                             account: account.address,
        //                             address: account.address,
        //                             network: (environment as any)[connectedChainId].CHAIN_NETWORK,
        //                             chainId: account.chainId,
        //                             provider: (environment as any)[connectedChainId].CHAIN_NETWORK,
        //                             chain: {
        //                                 id: account.chainId.toString(),
        //                                 unsupported: false
        //                             }
        //                         }
        //                     }
        //                 }
        //                 this.storageService.setItem('wagmi_new_store', JSON.stringify(new_wagmi_store))
        //                 this.storageService.setItem('wagmi_connected', 'true')
        //             } else {
        //                 this.switchNetworkModal?.show();
        //                 this.commonservices?.closeAllModals(true);
        //             }
        //             // const isSupportedNetwork = environment.DEFAULT_NETWORK == account.chainId.toString() ? false : true
        //         }
        //     }
        // });

        // watchAccount(this.appkitService.adapter.wagmiConfig , {
        //     onChange: (account: any) => {
        //         if (account.isConnected) {
        //             const connectedChainId = account.chainId.toString()
        //             if (environment.SUPPORTED_CHAINS.includes(connectedChainId)) {
        //                 this.switchNetworkModal?.hide();
        //                 this.commonservices?.closeAllModals(false);
        //             } else {
        //                 this.switchNetworkModal?.show();
        //                 this.commonservices?.closeAllModals(true);
        //             }
        //         }
        //     }
        // });

        // this.appkitService.switchNetworkModal$.subscribe((showModal) => {
        //     console.log('showModal---', showModal);
        //     if (showModal) {
        //         this.switchNetworkModal?.show();
        //         setTimeout(() => {
        //                 this.getWalletAddress();
        //             }, 500);
        //     } else {
        //         this.switchNetworkModal?.hide();
        //         this.idleService.logout();
        //         this.router.navigate(['/']);
        //     }
        // });

        // Watch for connection (network) changes
        // watchConnections(this.appkitService.adapter.wagmiConfig, {
        //     onChange: (connections) => {
        //         if (Array.isArray(connections) && connections.length != 0) {
        //             setTimeout(() => {
        //                 this.getWalletAddress();
        //             }, 500);
        //         } else {
        //             this.idleService.logout();
        //             this.router.navigate(['/']);
        //         }
        //     }
        // })
        // await reconnect(this.appkitService.adapter.wagmiConfig)
        // await reconnect(wagmi_config).then((isConnected) => { console.log("Account is connected: RealWorld.fi - Management ") })

    }

    // watchAccountConnections() {
    //     // Watch for connection (network) changes
    //     watchConnections(this.appkitService.adapter.wagmiConfig, {
    //         onChange: (connections) => {
    //             if (Array.isArray(connections) && connections.length != 0) {
    //                 setTimeout(() => {
    //                     this.getWalletAddress();
    //                 }, 500);
    //             } else {
    //                 this.idleService.logout();
    //                 this.router.navigate(['/']);
    //             }
    //         }
    //     })
    // }

    public connectWalletButton() {
        // this.web3Modal?.open();
        this.connector.openModal();
    }
    /**
       * Destroy
       */
    public ngOnDestroy() {
        clearInterval(this.checkNetworkInterval);
        if (this.custodyModeTimeout) {
            clearTimeout(this.custodyModeTimeout);
        }
        if (this.logoutTimeout) {
            clearTimeout(this.logoutTimeout);
        }
        this.unsubscribeSearch$.next();
        this.unsubscribeSearch$.complete();
    }
    /**
     * Checks whitelist
     */
    public async checkWhitelist() {
        const checkedWalletAddress = this.account.account;
        // A check for this wallet is already running — a duplicate "connected"
        // emission must not open a second signature request.
        if (this.whitelistCheckInFlightFor === checkedWalletAddress) return;
        this.whitelistCheckInFlightFor = checkedWalletAddress;

        try {
            const isWhitelisted = await this.nftManagementService.whiteListed(this.account);
            if (!isWhitelisted) {
                this.toastr.error("Your address is not whitelisted. Please contact your admin.");
                await disconnect(this.appkitService.adapter.wagmiConfig);
                if (this.router.url !== "/") {
                    this.ngzone.run(() => {
                        this.router.navigate(['/'])
                    });
                }
                return;
            }

            const currentWalletAddress = checkedWalletAddress;

            // Skip re-auth on refresh: if we already hold a live token for this wallet,
            // don't prompt the user to sign again. The interceptor will attach the token.
            if (this.hasValidSession(currentWalletAddress)) {
                this.idleService.reset();
                this.accountService.accountChange(true);
                // Sessions issued before the CSRF rollout hold no stored token.
                // Await the fetch so a state-changing request can't race ahead
                // of it and be sent without the X-CSRF-Token header.
                if (!this.storageService.getItem('csrfToken')) {
                    try {
                        const csrfResponse = await firstValueFrom(this.loginService.fetchCsrfToken());
                        const token = csrfResponse?.data?.csrf_token;
                        if (token) this.storageService.setItem('csrfToken', token);
                    } catch (_error) {
                        // best-effort; the interceptor still captures the token
                        // from the next backend response
                    }
                }
                if (this.router.url === '/') {
                    this.ngzone.run(() => this.router.navigate(['/dashboard']));
                }
                return;
            }

            // Challenge-verify wallet auth: prove wallet ownership by signing a server-issued nonce
            // before the backend issues a JWT. Protects against someone signing in with only a public address.
            const challenge: IApiResponse = await firstValueFrom(
                this.loginService.walletChallenge(currentWalletAddress)
            );
            const signature = await this.appkitService.signMessage(challenge.data.message);
            const response: IApiResponse = await firstValueFrom(
                this.loginService.walletVerify({
                    wallet_address: currentWalletAddress,
                    signature,
                    nonce: challenge.data.nonce
                })
            );

            this.storageService.setItem('token', response.data?.token);
            this.storageService.setItem('is_admin', response.data?.is_admin)
            this.storageService.setItem('walletAddress', response.data.wallet_address);
            this.storageService.setItem('expiryTime', JSON.stringify(response.data?.jwt_expiring_time));
            this.idleService.reset();
            this.accountService.accountChange(true);

            if (this.router.url === '/') {
                this.ngzone.run(() => {
                    this.router.navigate(['/dashboard']);
                });
            }
        } catch (error) {
            this.toastr.error('An error occurred. Please try again.');
        } finally {
            // Only release the guard we took — a check for a different wallet
            // may have started while this one was awaiting.
            if (this.whitelistCheckInFlightFor === checkedWalletAddress) {
                this.whitelistCheckInFlightFor = null;
            }
        }
    }
    /**
     * True when localStorage holds a non-expired JWT for the currently connected wallet.
     * Prevents the signature prompt from firing on every page refresh.
     */
    private hasValidSession(currentWalletAddress: string): boolean {
        const storedWalletAddress = this.storageService.getItem('walletAddress') || '';
        const expiryRaw = this.storageService.getItem('expiryTime');

        if (!storedWalletAddress) return false;
        if (storedWalletAddress.toLowerCase() !== currentWalletAddress.toLowerCase()) return false;

        const expiry = expiryRaw ? Number(JSON.parse(expiryRaw)) : 0;
        return Number.isFinite(expiry) && expiry > Date.now();
    }

    /**
     * Toggles menu
     */
    public toggleMenu(event: MouseEvent) {
        event.stopPropagation();
        this.showSearch = false;
        this.showMenu = !this.showMenu;
    }

    /**
     * Toggles the mobile search input (shown below the lg breakpoint).
     * Mutually exclusive with the menu so only one collapsible region is open at a time.
     * @param {MouseEvent} event - The originating click event.
     */
    public toggleSearch(event: MouseEvent) {
        event.stopPropagation();
        this.showMenu = false;
        this.showSearch = !this.showSearch;
    }

    @HostListener('window:click', ['$event'])
    onClick(event: MouseEvent) {
        const targetElement = this.navbarCollapse?.nativeElement;

        if (targetElement && event.target) {
            const clickedInside = targetElement.contains(event.target as Node);

            if (!clickedInside) {
                this.showMenu = false;
                this.showSearch = false;
            }
        }
    }

    /**
     * Recomputes the header's custody-mode fields from storage. When no
     * choice has been stored yet, the switcher shows
     * DEFAULT_CUSTODY_MODE_IS_REGULATED (Custody) without writing that
     * default back to storage — StorageService.getItemSession() resolves
     * unset reads to the same constant, so every other consumer (Regulated
     * request header, KYC gating, component data loads) already agrees with
     * the switcher until the user explicitly picks a mode via
     * setCustodyMode(). Must be re-run after any path that clears storage
     * (logout, wallet disconnect) while this component stays mounted, so
     * stale in-memory state can't cause setCustodyMode() to no-op on a value
     * that was never persisted.
     */
    private syncCustodyFromStorage(): void {
        this.hasExplicitCustodySelection = this.storageService.hasSessionValue('isRegulated');
        this.isRegulated = this.hasExplicitCustodySelection
            ? Boolean(this.storageService.getItemSession('isRegulated'))
            : DEFAULT_CUSTODY_MODE_IS_REGULATED;
    }

    /**
  * Sets regulated
  */
    public setRegulated() {
        this.setCustodyMode(!this.isRegulated);
    }

    public setCustodyMode(nextRegulated: boolean) {
        // Only skip when the current value was itself an explicit choice —
        // otherwise the very first click matching the UI-only default
        // (Custody) would silently no-op and never get persisted.
        if (this.hasExplicitCustodySelection && this.isRegulated === nextRegulated) return;

        this.storageService.setItemSession('isRegulated', nextRegulated);
        this.isRegulated = nextRegulated;
        this.hasExplicitCustodySelection = true;

        // If switching to Self-Custody (nextRegulated is false) from a custodial detail page
        if (!nextRegulated && (
            this.router.url.includes('manage-user/user-profile') || 
            this.router.url.includes('manage-user/kyc-history') ||
            this.router.url.includes('manage-user/holding') ||
            this.router.url.includes('manage-user/active-loans') ||
            this.router.url.includes('manage-user/history') ||
            this.router.url.includes('manage-user/introducer') ||
            this.router.url.includes('manage-user/log-history')
        )) {
            this.router.navigate(['/manage-user']);
        }

        if (nextRegulated) {
            this.router.navigate(['/manage-user']);
        }

        this.custodyModeTimeout = setTimeout(() => {
            window.location.reload();
        }, 500);
    }
    /**
     * Logout
     */
    async logout() {
        this.toastr.error('Authentication failed. Please login again');
        // await disconnect();
        this.accountService.authValidationsUpdate(false);
        this.idleService.logout();
        this.logoutTimeout = setTimeout(() => {
            this.router.navigate(['/']);
        }, 1000);
    }

    /**
     * Switchs network
     * @param {string} chainId
     */
    switchNetwork(chainId: any) {
        switchChain(this.appkitService.adapter.wagmiConfig, { chainId }).catch((error) => {
            console.error(error.message)
        })
    }
    /**
     * search dropdwon
     */
    showDropdown() {
        this.searchDropdown = !this.searchDropdown;
    }

    @HostListener('document:click', ['$event'])
    clickout(event: Event) {
        this.account = this.storageService.getItem('wagmi_new_store') === null ?
            { "state": { "data": { "account": "", "chain": { "id": environment.SUPPORTED_CHAINS[0] } } } } :
            JSON.parse(this.storageService.getItem('wagmi_new_store') as any);
        // if (!this._eref.nativeElement.contains(event.target) && this.account.state.data.account) {
        //     this.searchDropdown = false;
        //     this.quickSearchBox.nativeElement.value = '';
        // }
    }

    /**
     * Quicks search
     */
    quickSearch() {
        this.searchData = {};
        this.resetSearchParams();
        this.searchDropdown = true;
        this.searchLoader = true;

    }

    /**
     * Quicks search process
     * @param {string} keyWord
     */
    quickSearchProcess(keyWord: string, selectedSection?: string) {
        this.searchKey = keyWord;
        if(keyWord === '') {
            this.searchData = {};
            this.searchDropdown = !this.searchDropdown;
            return;
        }
        // Set the loader for the selected section to true
        if (selectedSection) {
            this.loadingStates[selectedSection] = true;
        }
        this.incrementPage(selectedSection);
        this.searchService.searchItems(
            keyWord,
            this.account.account,
            this.limit,
            this.searchParams.logPage,
            this.searchParams.collectionPage,
            this.searchParams.nftPage,
            this.searchParams.userPage,
            this.searchParams.holdingPage
        ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: (response: IApiResponse) => {
                // Ensure this.searchData is initialized
                if (!this.searchData) {
                    this.searchData = {};
                }
                this.updateShowMore(response.data);

                // Loop through all keys in the response
                for (let key in response.data) {
                    if (response.data.hasOwnProperty(key)) {
                        // Check if the key already exists in this.searchData
                        if (this.searchData[key]) {
                            // If it's an array, append new data
                            if (Array.isArray(this.searchData[key])) {
                                // Check for duplicates before appending
                                const newItems = response.data[key].filter((newItem: any) =>
                                    !this.searchData[key].some((existingItem: any) => existingItem._id === newItem._id)
                                );
                                this.searchData[key] = [...this.searchData[key], ...newItems];
                            } else {
                                // If it's an object, merge the objects
                                this.searchData[key] = { ...this.searchData[key], ...response.data[key] };
                            }
                        } else {
                            // Initialize the key with the response data if it doesn't exist yet
                            this.searchData[key] = Array.isArray(response.data[key]) ? [...response.data[key]] : { ...response.data[key] };
                        }
                    }
                }
                this.searchLoader = false;
                if (selectedSection) {
                    this.loadingStates[selectedSection] = false;
                }
            },
            error: (error) => {
                this.searchLoader = false;
                console.error('Error fetching search results', error);
                if (selectedSection) {
                    this.loadingStates[selectedSection] = false;
                }
            }
        });

    }

    /**
     * Increments the page number for the specified search type.
     * @param section - The section for which to increment the page.
     */
    private incrementPage(section?: string): void {
        if (!section) return;

        switch (section) {
            case searchType.log:
                this.searchParams.logPage++;
                break;
            case searchType.collection:
                this.searchParams.collectionPage++;
                break;
            case searchType.nft:
                this.searchParams.nftPage++;
                break;
            case searchType.user:
                this.searchParams.userPage++;
                break;
            case searchType.holding:
                this.searchParams.holdingPage++;
                break;
            default:
                break;
        }
    }

    /**
     * Resets search
     */
    resetSearch() {
        this.quickSearchBox.nativeElement.value = '';
        this.searchDropdown = false;
        this.searchData = {};
        this.resetSearchParams();
    }

    /**
     * reset search parameters to their initial values
     */
    resetSearchParams(): void {
        this.searchParams = {
            logPage: 1,
            collectionPage: 1,
            nftPage: 1,
            userPage: 1,
            holdingPage: 1
        };
    }

    /**
     * Updates the state of whether the "See More" Button can be shown for different entities
     * based on the current page number and the total available pages for each entity.
     *
     * @param {Object} data - The object containing total page counts for various entities.
     */
    updateShowMore(data: any): void {
        const { log_total_page, collection_total_page, nft_total_page, user_total_page, user_holding_total_page } = data;
        this.canShowSeeMore = {
            log: log_total_page > this.searchParams.logPage,
            collection: collection_total_page > this.searchParams.collectionPage,
            nft: nft_total_page > this.searchParams.nftPage,
            user: user_total_page > this.searchParams.userPage,
            holding: user_holding_total_page > this.searchParams.holdingPage
        };
    }

    @HostListener('document:click', ['$event'])
    /**
     * Handles a click event on the document. If the target element is not inside the quick search box or the search component, it sets searchDropdown to false.
     * @param event - The MouseEvent triggered by the click event.
     */
    handleClick(event: MouseEvent) {
        const clickedInside =
        this.quickSearchBox?.nativeElement.contains(event.target) ||
        (event.target as HTMLElement).closest('app-search-component');

        if (!clickedInside) {
        this.searchDropdown = false;
        }
    }


}

export enum searchType {
    log = 'log',
    collection = 'collection',
    nft = 'nft',
    user = 'user',
    holding = 'holding'
}

export interface ICanShowSeeMore {
    log: boolean;
    collection: boolean;
    nft: boolean;
    user: boolean;
    holding: boolean;
}
